module.exports = __webpack_public_path__ + "static/media/wizualizacja-113.d7dc0c6e.png";